'use strict';
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { 'default': mod };
};
Object.defineProperty(exports, '__esModule', { value: true });
const draft_js_1 = require('draft-js');
const EntityTypes_1 = __importDefault(require('../EntityTypes'));
const ramda_1 = require('ramda');
const findAllEntities_1 = require('../findAllEntities');
const getBranchFields_1 = require('../getBranchFields');
const getSynonymFields_1 = require('../getSynonymFields');
exports.defaultTransformers = {
    branch: ramda_1.identity,
    data: ramda_1.identity,
    synonym: ramda_1.identity,
    branchField: ramda_1.identity,
    slotField: ramda_1.identity,
    synonymField: ramda_1.identity
};
const mapWhile = (mapFn, predFn, a) => {
    let index = 0;
    const len = a.length;
    const result = [];
    while (index < len) {
        const b = mapFn(a[index]);
        result.push(b);
        if (!predFn(b)) {
            break;
        }
        index += 1;
    }
    return result;
};
const shouldStopReducing = ({stopReducing}) => !stopReducing;
const extractValue = ({value}) => value;
exports.createSnapshotReducer = config => {
    return (context, rootId) => reduceDraftState({
        subject: rootId,
        config,
        context
    }).value;
};
const reduceDraftState = ({
    subject: draftId,
    context,
    config
}) => {
    const {draftStates} = context.snapshot;
    const draftState = draftStates[draftId];
    if (draftState) {
        const contentResult = reduceContentState({
            subject: draft_js_1.convertFromRaw(draftState),
            context,
            config
        });
        if (config.visitors.draftState) {
            return config.visitors.draftState({
                subject: {
                    draftState,
                    draftId
                },
                childResults: [contentResult.value],
                context,
                config
            });
        }
        return contentResult;
    }
    return { value: config.defaultValue };
};
const reduceContentState = _a => {
    var {subject: contentState} = _a, rest = __rest(_a, ['subject']);
    const entities = findAllEntities_1.findAllEntities(contentState);
    const entityResults = mapWhile(entity => {
        return reduceEntity(Object.assign({ subject: entity }, rest));
    }, shouldStopReducing, entities).map(extractValue);
    return rest.config.visitors.contentState(Object.assign({
        subject: contentState,
        childResults: entityResults
    }, rest));
};
exports.isDataEntity = entity => {
    return entity.type === EntityTypes_1.default.DATA;
};
exports.isSynonymEntity = entity => {
    return entity.type === EntityTypes_1.default.SYNONYM;
};
exports.isBranchEntity = entity => {
    return entity.type === EntityTypes_1.default.BRANCH;
};
const reduceEntity = _a => {
    var {subject: entity} = _a, rest = __rest(_a, ['subject']);
    if (exports.isBranchEntity(entity)) {
        return reduceBranchEntity(Object.assign({ subject: entity }, rest));
    }
    if (exports.isDataEntity(entity)) {
        return reduceDataEntity(Object.assign({ subject: entity }, rest));
    }
    if (exports.isSynonymEntity(entity)) {
        return reduceSynonymEntity(Object.assign({ subject: entity }, rest));
    }
    return { value: rest.config.defaultValue };
};
const reduceBranchEntity = ({
    subject: branch,
    context,
    config
}) => {
    const {visitors, transformers} = config;
    const newBranch = transformers.branch(branch);
    const {branchFields} = context.snapshot;
    const fields = getBranchFields_1.getBranchFields({
        branchId: branch.entityId,
        branchFields
    });
    const fieldResults = mapWhile(field => reduceBranchField({
        subject: field,
        context,
        config
    }), shouldStopReducing, fields).map(({value}) => value);
    return visitors.branch({
        subject: newBranch,
        childResults: fieldResults,
        context,
        config
    });
};
const reduceBranchField = ({
    subject: field,
    context,
    config,
    parent
}) => {
    const {visitors, transformers} = config;
    const newField = transformers.branchField(field);
    const contentResult = reduceDraftState({
        subject: field.localId,
        context,
        config
    });
    const slotFieldResults = mapWhile(slotField => reduceSlotField({
        subject: slotField,
        context,
        config,
        parent: newField
    }), shouldStopReducing, field.slotFields || []).map(({value}) => value);
    return visitors.branchField({
        subject: newField,
        childResults: [
            contentResult.value,
            ...slotFieldResults
        ],
        context,
        config,
        parent
    });
};
const reduceSlotField = ({
    subject: field,
    context,
    config,
    parent
}) => {
    const {visitors, transformers} = config;
    const newField = transformers.slotField(field);
    const contentResult = reduceDraftState({
        subject: field.localId,
        context,
        config
    });
    return visitors.slotField({
        subject: newField,
        childResults: [contentResult.value],
        context,
        config,
        parent
    });
};
const reduceSynonymEntity = ({
    subject: synonym,
    context,
    config
}) => {
    const {visitors, transformers} = config;
    const newSynonym = transformers.synonym(synonym);
    const {synonymFields} = context.snapshot;
    const fields = getSynonymFields_1.getSynonymFields({
        synonymId: synonym.entityId,
        synonymFields
    });
    const fieldResults = mapWhile(field => reduceSynonymField({
        subject: field,
        context,
        config
    }), shouldStopReducing, fields).map(({value}) => value);
    return visitors.synonym({
        subject: newSynonym,
        childResults: fieldResults,
        context,
        config
    });
};
const reduceSynonymField = ({
    subject: field,
    context,
    config
}) => {
    const {visitors, transformers} = config;
    const newField = transformers.synonymField(field);
    const contentResult = reduceDraftState({
        subject: field.localId,
        context,
        config
    });
    return visitors.synonymField({
        subject: newField,
        childResults: [contentResult.value],
        context,
        config
    });
};
const reduceDataEntity = ({
    subject: data,
    context,
    config
}) => {
    const {visitors, transformers} = config;
    const newData = transformers.data(data);
    return visitors.data({
        subject: newData,
        childResults: [],
        context,
        config
    });
};    //# sourceMappingURL=data:application/json;base64,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
